import { computed, type Ref } from "vue"

/**
 * Composable to get the appropriate "Drug Product Mass per Product Format" label
 * based on the selected product format.
 *
 * Uses massQuantityLabelText from database if available, otherwise defaults to "Mass per product format"
 */
export function useProductFormatLabel(
	productFormatName: Ref<string | null | undefined>,
	massQuantityLabelText: Ref<string | null | undefined>
) {
	const massPerProductFormatLabel = computed(() => {
		// Use massQuantityLabelText from database if available
		if (massQuantityLabelText.value) {
			return massQuantityLabelText.value
		}

		// Default label if no custom text is defined
		return "Drug Product Mass per Product Format"
	})

	return {
		massPerProductFormatLabel,
	}
}
